/* eslint-disable max-len */
import constants from 'src/common/constants';

export const getDefaultLocation = (state) => state.all.find((location) => location.id === constants.DEFAULT_LOCATION);
